import { frontendURL } from '../../../helper/URLHelper';
import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentAI from './agentAI/agentAI.routes';
import analytics from './analytics/analytics.routes';
import attributes from './attributes/attributes.routes';
import inbox from './inbox/inbox.routes';
import profile from './profile/profile.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      roles: ['administrator', 'agent'],
      redirect: (to) => ({
        name: 'personal_preferences_settings_index',
        params: to.params,
        query: to.query,
      }),
    },
    // Otello da mobile: elenco delle impostazioni (barra in basso).
    {
      path: frontendURL('accounts/:accountId/settings/all'),
      name: 'settings_center_mobile',
      roles: ['administrator', 'agent'],
      component: () => import('./MobileSettingsIndex.vue'),
    },
    ...account.routes,
    ...agent.routes,
    ...agentAI.routes,
    ...analytics.routes,
    ...attributes.routes,
    ...inbox.routes,
    ...profile.routes,
  ],
};
